export default [
    {
        id: 1,
        title: "Facebook",
        coverImg: "facebook.webp",
        route: "facebook",

    },
    {
        id: 2,
        title: "Instagram",
        coverImg: "instagram.webp",
        route: "instagram",
    },
    {
        id: 3,
        title: "Twitter",
        coverImg: "twitter.png",
        route: "twitter",
    },
    {
        id: 4,
        title: "Snapchat",
        coverImg: "snapchat.webp",
        route: "snapchat",
    },
    {
        id: 5,
        title: "TikTok",
        coverImg: "tiktok.png",
        route: "tiktok",
    },
    {
        id: 6,
        title: "Reddit",
        coverImg: "reddit.webp",
        route: "reddit",
    }
    ,
    {
        id: 7,
        title: "LinkedIn",
        coverImg: "linkedin.webp",
        route: "linkedin",
    },
    {
        id: 8,
        title: "WhatsApp",
        coverImg: "whatsapp.webp",
        route: "whatsapp",
    }
]